/**
 * Metadatos del **portal del cliente**.
 *
 * `version` sale de `package.json` (ver `vite.config.ts`): es el número que
 * muestra el pie del portal, igual que en el panel.
 */
export const APP_META = {
  name: 'EDSuite · Portal del cliente',
  version: __APP_VERSION__,
  vendor: 'Escienza',
  vendorUrl: 'https://escienza.pe',
} as const;
